import { LitElement, css, html, svg, ref, createRef } from 'lit'


const backArrow = svg`
<svg width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.3333 27.3334L0 14.0001L13.3333 0.666748L15.7 3.03341L4.73333 14.0001L15.7 24.9667L13.3333 27.3334Z" fill="#1C1B1F"/>
</svg>
`

const searchIcon = svg`
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.6 18L10.3 11.7C9.8 12.1 9.225 12.4167 8.575 12.65C7.925 12.8833 7.23333 13 6.5 13C4.68333 13 3.14583 12.3708 1.8875 11.1125C0.629167 9.85417 0 8.31667 0 6.5C0 4.68333 0.629167 3.14583 1.8875 1.8875C3.14583 0.629167 4.68333 0 6.5 0C8.31667 0 9.85417 0.629167 11.1125 1.8875C12.3708 3.14583 13 4.68333 13 6.5C13 7.23333 12.8833 7.925 12.65 8.575C12.4167 9.225 12.1 9.8 11.7 10.3L18 16.6L16.6 18ZM6.5 11C7.75 11 8.8125 10.5625 9.6875 9.6875C10.5625 8.8125 11 7.75 11 6.5C11 5.25 10.5625 4.1875 9.6875 3.3125C8.8125 2.4375 7.75 2 6.5 2C5.25 2 4.1875 2.4375 3.3125 3.3125C2.4375 4.1875 2 5.25 2 6.5C2 7.75 2.4375 8.8125 3.3125 9.6875C4.1875 10.5625 5.25 11 6.5 11Z" fill="#1C1B1F"/>
</svg>
`

const clearIcon = svg`
<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.2 16.375L0.625 14.8L6.925 8.5L0.625 2.2L2.2 0.625L8.5 6.925L14.8 0.625L16.375 2.2L10.075 8.5L16.375 14.8L14.8 16.375L8.5 10.075L2.2 16.375Z" fill="#1C1B1F"/>
</svg>
`

const replacer = {
    "q":"й", "w":"ц", "e":"у", "r":"к", "t":"е", "y":"н", "u":"г",
    "i":"ш", "o":"щ", "p":"з", "[":"х", "]":"ъ", "a":"ф", "s":"ы",
    "d":"в", "f":"а", "g":"п", "h":"р", "j":"о", "k":"л", "l":"д",
    ";":"ж", "'":"э", "z":"я", "x":"ч", "c":"с", "v":"м", "b":"и",
    "n":"т", "m":"ь", ",":"б", ".":"ю", "/":"."
}


function replaceEnglish(str) {
    return str.replace(/[A-z/,.;\'\]\[]/g, x => {
        return x == x.toLowerCase() ? replacer[x] : replacer[x.toLowerCase()].toUpperCase()
    })
}


export class MobileMenu extends LitElement {

    $searchfield = createRef()

    connectedCallback() {
        super.connectedCallback()
        this.catalog = JSON.parse(this.children[0].textContent)
        this.searchlist = JSON.parse(this.children[1].textContent)
        this.index = FlexSearch.Index({
            charset: "utf-8",
            preset: "performance",
            tokenize: "forward",
            resolution: 2
        })

        for (let [n, item] of Object.entries(this.searchlist)) {
            this.index.add(n, item.name)
        }


        if (this.catalog) {
            this.pages = [Object.entries(this.catalog)]
            this.breadcrumbs = ["Каталог"]
            this.currentPage = 0
        }

        this.searchButtons = {
            find: html`<button>${searchIcon}</button>`,
            clear: html`<button @click=${this.clearSearch}>${clearIcon}</button>`
        }
    }


    render() {
        let mainHTML = []
        if (this.pages && !this.searchResults) {
            let pagenum = 0
            for (let page of this.pages) {
                let pageHTML = [],            
                    toolbarHTML = []
                if (pagenum) {
                    toolbarHTML.push(html`
                        <button @click=${this.removePage} class="breadcrumb">
                            ${backArrow}
                            <div>${this.breadcrumbs[pagenum-1]}</div>
                        </button>
                    `)
                }

                pageHTML.push(html`
                    <div class="toolbar">${toolbarHTML}</div>
                    <div class="title">${this.breadcrumbs[pagenum]}</div>
                `)

                for (let [name, content] of page) {
                    pageHTML.push(html`
                        <div class="entry" @click=${() => this.addPage(name, content)}>${name}</div>
                    `)
                }                
                mainHTML.push(html`
                    <div class="page num${pagenum}" style="z-index: ${pagenum}">${pageHTML}</div>
                `)
                pagenum += 1
            }
        }

        if (this.searchResults) {
            if (this.searchResults.length) {
                let pageHTML = []
                for (let found of this.searchResults) {
                    pageHTML.push(html`<a class="found" href=${found.link}>${found.name}</a>`)
                }
                mainHTML = html`<div class="page">${pageHTML}</div>`
            } else {
                mainHTML.push(html`<div class="page"><div class="title">Не найдено</div></div>`)
            }
        }

        return html`<div class="box">
            <div class="searchfield">
                <input type="text" ${ref(this.$searchfield)} @input=${this.search}>
                ${this.searchResults ? this.searchButtons.clear : this.searchButtons.find}
            </div>
            ${mainHTML}
        </div>`
    }


    addPage(name, content) {
        if (typeof content == 'object') {
            this.pages.push(Object.entries(content))
            this.breadcrumbs.push(name)
            this.currentPage += 1
            this.requestUpdate()
        } else {
            window.location.href = `/catalog/${content}/`
        }
    }


    removePage() {
        if (this.pages.length > 1) {
            let page = this.renderRoot.querySelector(`.page.num${this.currentPage}`)
            page.style.animation = `ease-out slide-out 0.3s forwards`

            page.addEventListener("animationend", () => {
                this.currentPage -= 1
                this.pages.pop()
                this.breadcrumbs.pop()
                this.requestUpdate()
            })
        }
    }


    clearSearch() {
        this.$searchfield.value.value = ""
        this.searchResults = null
        this.requestUpdate()
    }


    search() {
        if (this.$searchfield.value.value.length  > 2) {
            let token = this.$searchfield.value.value
            if (/[a-zA-Z]/.test(token)) {
                token = replaceEnglish(token)
            }
            this.searchResults = this.index.search(token, 20).map(n => this.searchlist[n])
            
        } else {
            if (this.searchResults) {
                this.searchResults = null
            }
        }
        this.requestUpdate()
    }


    static get styles() {
        return css`
            :host {
                font-family: "Roboto";
                font-size: 12px;
                position: fixed;
                top: 0px;
                left: 100vw;
                width: 100vw;
                height: 100dvh;
                transition: 0.4s;
                background: white;
                z-index: 100;
            }

            :host(.visible) {
                left: 0vw;
            }

            .box {
                width: 100%;
                height: 100%;
            }

            .page {
                position: absolute;
                top: 60px;
                left: 0px;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                overflow: hidden auto;
                gap: 10px;
                background: white;
                animation: ease-out slide-in 0.3s forwards;
                padding: 20px;
                padding-bottom: 200px;
                box-sizing: border-box;
            }

            .page .found {
                color: black;
                text-decoration: none;
            }

            .toolbar {
                display: flex;
                flex-direction: column;
                gap: 10px;
            }

            .breadcrumb {
                display: flex;
                align-items: center;
                gap: 20px;
                appearance: none;
                border: none;
                background: none;
                font-family: 'Roboto Medium';
                font-size: 15px;
                border-bottom: solid #0001 1px;
                padding-bottom: 10px;
                width: 100%
            }

            .breadcrumb svg {
                transform: scale(0.5) translate(-10px, 0px);;
            }

            .title {
                font-family: 'Roboto Medium';
                font-size: 20px;
            }

            .searchfield {
                position: relative;
                display: flex;
                align-items: center;
                background: white;
                z-index: 100;
                padding: 20px
            }

            .searchfield input {
                width: 100%;
                height: 30px;
                appearance: none;
                background: #0001;
                border: none;
                border-radius: 8px;
                padding: 0px 45px 0px 10px;
                box-sizing: border-box;
            }

            .searchfield input:focus {
                outline: none;
            }

            .searchfield button {
                position: absolute;
                right: 25px;
                height: 30px;
                width: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                appearance: none;
                background: none;
                border: none;
            }

            @keyframes slide-in {
                from {
                    left: 100%;
                }
                to {
                    left: 0%;
                }
            }

            @keyframes slide-out {
                from {
                    left: 0%;
                }
                to {
                    left: 100%;
                }
            }
        `
    }
}

window.customElements.define("mobile-menu", MobileMenu)